module.exports = __webpack_public_path__ + "img/home-2-phonepeople.daa25208.png";